import { ADMIN_OR_ABOVE } from "@excel-center/shared";
import { lazy } from "react";
import type { RouteObject } from "react-router";
import { ProtectedRoute } from "@/src/auth/components/protected-route";
import { JOBS_ROUTES } from "@/src/jobs/constants/jobs-routes.constants";

const PublicJobsPage = lazy(() => import("@/src/jobs/pages/public-jobs.page"));
const JobsPage = lazy(() => import("@/src/jobs/pages/jobs.page"));
const JobsManagementPage = lazy(() => import("@/src/jobs/pages/jobs-management.page"));

export const jobsPublicRoutes: RouteObject[] = [{ path: JOBS_ROUTES.jobs, element: <PublicJobsPage /> }];

export const jobsAuthedRoutes: RouteObject[] = [
	{ path: JOBS_ROUTES.appJobs, element: <JobsPage /> },
	{
		path: JOBS_ROUTES.appJobsManage,
		element: (
			<ProtectedRoute requiredRole={[...ADMIN_OR_ABOVE]}>
				<JobsManagementPage />
			</ProtectedRoute>
		),
	},
];
